import { type ShapeProps } from './Ripple'

export const PawShape = (props: ShapeProps) => {
  const { rootRef, ...rest } = props
  return (
    <svg viewBox="0 0 100 100" ref={rootRef} {...rest}>
      {/* Main pad */}
      <ellipse cx="50" cy="70" rx="18" ry="15" />
      {/* Top left toe */}
      <ellipse cx="28" cy="45" rx="9" ry="11" />
      {/* Top center-left toe */}
      <ellipse cx="40" cy="35" rx="9" ry="11" />
      {/* Top center-right toe */}
      <ellipse cx="60" cy="35" rx="9" ry="11" />
      {/* Top right toe */}
      <ellipse cx="72" cy="45" rx="9" ry="11" />
    </svg>
  )
}
